/* eslint-disable */
import Vue from 'vue'
import Router from 'vue-router'
// 要使用該 api 的檔案，使用 import將方法載入
// import { postFunc } from '../apis/apis'
// import HelloWorld from '@/components/HelloWorld'
// import Index from '@/page/Index'
// import Index2 from '@/page/Index2'
// import UserProfile from '@/page/UserProfile'

Vue.use(Router)

// req.apiPostEmb({ account: 'Bernie.chen', date: '202003' }).then((response) => {
//     Console.log(response)
// })

// const post1 = postFunc({ 'account': 'Bernie.chen', 'date': '202003' })
// debugger
// console.log(post1)

// 呼叫menuBundle.js
// var bundelTest = require('./menuBundle')
var bundelTest = require('./routerSetting')

// 呼叫menuList function 組合Router
bundelTest.getMenuList()

var router = new Router({
    // remove hashbang from url(移除URL出現#號)
    mode: 'history',
    // base:'/tac/',    // 先註解起來避免人才永續頁面失效。
    routes: bundelTest.resultList
})
export default router
// 原先路由
// export default new Router({
//   routes: [{
//     path: '/',
//     name: '首頁',
//     component: () =>
//                 import('@/page/Index')
//   },
//   {
//     path: '/web-map',
//     name: '網站導覽',
//     component: () =>
//                 import('@/page/web-map')
//   },
//   {
//     path: '/management-philosophy',
//     name: '經營理念',
//     component: () =>
//                 import('@/page/management-philosophy')
//   },
//   {
//     path: '/management-group',
//     name: '經營團隊',
//     component: () =>
//                 import('@/page/management-group')
//   },
//   {
//     path: '/certificate',
//     name: '榮譽獎項',
//     component: () =>
//                 import('@/page/certificate')
//   },
//   {
//     path: '/related-company',
//     name: '關係企業',
//     component: () =>
//                 import('@/page/related-company')
//   },
//   {
//     path: '/product-service',
//     name: '產品及服務',
//     component: () =>
//                 import('@/page/product-service')
//   },
//   {
//     path: '/business/stakeholder',
//     name: '利害關係人',
//     component: () =>
//                 import('@/page/business/stakeholder')
//   },
//   {
//     path: '/business/business',
//     name: '公司治理',
//     component: () =>
//                 import('@/page/business/business')
//   },
//   {
//     path: '/company-info',
//     name: '基本資料',
//     component: () =>
//                 import('@/page/company-info')
//   },
//   {
//     path: '/recruiting/salary',
//     name: '薪資福利',
//     component: () =>
//                 import('@/page/recruiting/salary')
//   },
//   {
//     path: '/recruiting/nurture',
//     name: '多元培育',
//     component: () =>
//                 import('@/page/recruiting/nurture')
//   },
//   {
//     path: '/recruiting/recruit',
//     name: '招募訊息',
//     component: () =>
//                 import('@/page/recruiting/recruit')
//   },
//   {
//     path: '/recruiting/employee-safety',
//     name: '員工安全與工作環境',
//     component: () =>
//                 import('@/page/recruiting/employee-safety')
//   },
//   {
//     path: '/csr/csr-01',
//     name: '經營者的話',
//     component: () =>
//                 import('@/page/csr/csr-01')
//   },
//   {
//     path: '/csr/csr-02',
//     name: '組織體制',
//     component: () =>
//                 import('@/page/csr/csr-02')
//   },
//   {
//     path: '/Index2',
//     name: '新聞中心',
//     component: () => import('@/page/Index2'),
//     children: [
//       {
//         // 当 /user/:id/profile 匹配成功，
//         // UserProfile 会被渲染在 User 的 < router-view> 中
//         path: 'profile',
//         name: 'profile',
//         component: () => import('@/page/UserProfile')
//       },
//       {
//         name: '經營理念',
//         path: 'management-philosophy',
//         component: () => import('@/page/management-philosophy')
//       }
//     ]
//   }
//   ]
// })


// WEBPACK FOOTER //
// ./src/router/index.js